<template>
  <v-icon :class="computedClass" :color="color" :size="size">
    {{ icon }}
  </v-icon>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: '',
    },

    lib: {
      type: String,
      default: 'mdi',
      validator: (val) => ['mdi', 'md'].includes(val),
    },

    color: {
      type: String,
      default: undefined,
    },

    size: {
      type: String,
      default: 'default',
    },

    animation: {
      type: String,
      required: false,
    },
  },
  computed: {
    isMDLib() {
      return this.lib === 'md' || this.icon.startsWith('md:');
    },
    computedClass() {
      const classes = ['ag-icon', { 'material-symbols-outlined': this.isMDLib }];

      if (this.animation) classes.push(`ag-icon--animation-${this.animation}`);

      return classes;
    },
  },
};
</script>

<style scoped lang="scss">
.ag-icon {
  &--animation-spin {
    animation: spin 1s infinite linear;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}
</style>
